import { cn } from "@omni/utils/styles";
import { useState } from "react";

import { ColorswatchFacetDisplayValue } from "@/components/Search/SearchResults/StateComponents/Facets/Facet/components/ColorswatchFacet/colorswatchFacet.container";

type ColorswatchFacetValueComponentProps = {
    value: ColorswatchFacetDisplayValue;
};

const ColorswatchFacetValueComponent = ({
    value
}: ColorswatchFacetValueComponentProps) => {
    const [isRefinedOptimistic, setIsRefinedOptimistic] = useState<boolean>(
        value.refined
    );

    const handleOnClick = () => {
        setIsRefinedOptimistic((isChecked) => !isChecked);
        value.onRefine();
    };

    return (
        <li>
            <button
                type={"button"}
                className={cn(
                    "tw:w-10 tw:h-10 tw:cursor-pointer tw:p-0.75 tw:m-1 tw:border-2 tw:text-grey-input tw:rounded-md tw:bg-transparent",
                    {
                        "tw:border-information tw:border-3 tw:p-0.5":
                            isRefinedOptimistic
                    }
                )}
                onClick={handleOnClick}
            >
                <img
                    className={cn("tw:w-full tw:h-full tw:rounded-sm")}
                    title={value.label}
                    src={value.url}
                    alt={value.label}
                />
            </button>
        </li>
    );
};

export { ColorswatchFacetValueComponent };
